import { Controller } from '../utils/controller';

const INTERSECTION_OBSEVER_OPTIONS = {
  root: null, // use the viewport as the root
  rootMargin: '0px', // margin around the root, can have values like '10px', '10% 20%', etc.
  threshold: 0.1 // target element is considered visible if it covers at least 10% of the viewport
};

export default class extends Controller {
  static targets = ['modal'];

  declare modalTarget: HTMLElement;
  declare hasModalTarget: boolean;

  connect(): void {
    if (this.hasModalTarget) {
      const observer = new IntersectionObserver(
        this.handleIntersection,
        INTERSECTION_OBSEVER_OPTIONS
      );
      observer.observe(this.modalTarget);
    }
  }

  handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && this.isEntryModal(entry.target)) {
        document.body.classList.add('overflow-hidden');
        document.documentElement.classList.add('overflow-hidden');
      } else {
        document.body.classList.remove('overflow-hidden');
        document.documentElement.classList.remove('overflow-hidden');
      }
    });
  };

  isEntryModal = (entryTarget: HTMLElement) => {
    return entryTarget.id === this.modalTarget.id;
  };
}
